export default {"src":"/_next/static/media/key-mobile.ebd5fd1f.svg","height":156,"width":63,"blurWidth":0,"blurHeight":0};